/**
 * Article Grid pagination — trims page-number pills to whatever fits the
 * available width, anchored on the current page.
 *
 * Every click here is a real link (full page load, no SPA routing), so the
 * "sliding window" behaviour is just this same computation running again on
 * the next page with a new current page — no client-side navigation state
 * to track.
 *
 * Fill order: from the current page, fill up to 2 pages ahead first, then
 * fill backwards with whatever slots are left. On page 1 that means the
 * window fills forward only, dropping the pages closest to the "Next"
 * chevron first when everything doesn't fit. Landing on the last page
 * visible in a window shifts it forward by up to 2 and drops the same
 * number of pages from the left.
 */
(function () {
  'use strict';

  var PILL_WIDTH = 46;
  var GAP = 10;
  var MIN_SLOTS = 3;
  var LOOKAHEAD = 2;
  function computeWindow(total, current, maxSlots) {
    if (maxSlots >= total) {
      return {
        start: 1,
        end: total
      };
    }
    var start = current;
    var end = Math.min(current + LOOKAHEAD, total);
    var remaining = maxSlots - (end - start + 1);
    while (remaining > 0 && start > 1) {
      start -= 1;
      remaining -= 1;
    }
    while (remaining > 0 && end < total) {
      end += 1;
      remaining -= 1;
    }
    return {
      start: start,
      end: end
    };
  }
  function updatePagination(nav) {
    var numEls = Array.prototype.slice.call(nav.querySelectorAll('.ag-pag-num'));
    if (!numEls.length) return;
    var nextEl = nav.querySelector('.ag-pag-next');
    var currentEl = nav.querySelector('.ag-pag-num[aria-current="page"]');
    var currentPage = currentEl ? parseInt(currentEl.getAttribute('data-page'), 10) : 1;

    // Reset before measuring so a previous, narrower computation can't
    // starve this one of width it should actually have back.
    numEls.forEach(function (el) {
      el.hidden = false;
    });
    var container = nav.parentElement || nav;
    var availableWidth = container.clientWidth;
    var nextWidth = nextEl ? nextEl.getBoundingClientRect().width + GAP : 0;
    var usableWidth = availableWidth - nextWidth;
    var maxSlots = Math.floor((usableWidth + GAP) / (PILL_WIDTH + GAP));
    maxSlots = Math.max(MIN_SLOTS, maxSlots);
    var range = computeWindow(numEls.length, currentPage, maxSlots);
    numEls.forEach(function (el) {
      var page = parseInt(el.getAttribute('data-page'), 10);
      el.hidden = page < range.start || page > range.end;
    });
  }
  function init() {
    var navs = Array.prototype.slice.call(document.querySelectorAll('[data-ag-pagination]'));
    if (!navs.length) return;
    navs.forEach(updatePagination);
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        navs.forEach(updatePagination);
      }, 150);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();